export const environment = {
  production: true,
  environment: "開発環境",
  apiHost: "opca-api-dev.facere.biz",
  firebase: {
    apiKey: "AIzaSyCoQIEzkPg9keZ0_fl8mRa0lTqDCWXjaH0",
    authDomain: "facere-opca-dev.firebaseapp.com",
    projectId: "facere-opca-dev",
    storageBucket: "facere-opca-dev.firebasestorage.app",
    messagingSenderId: "408579177609",
    appId: "1:408579177609:web:49cfc919e50011d5f6da58",
    measurementId: "G-182T050GV4"
  },
  googleAnalytics4ReportUrl: "https://lookerstudio.google.com/embed/reporting/f8a373d0-5922-4f35-a742-c6e30411a57c/page/tEnnC",
};
